<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        title="Custom Columns"
        :visible.sync="dialogVisible"
        width="1100px"
        top="5vh"
        :before-close="handleClose"
        custom-class="custom-indicator apple-custom-indicator"
        >
        <div class="body-content" :style="{height: dialogHeight, overflow: 'auto'}">
            <div class="wrapper">
                <!-- 主内容区 -->
                <div style="flex: auto;">
                    <div class="top-wrapper">
                        <el-input
                        class="search"
                        v-model="keyword"
                        suffix-icon="el-icon-search"
                        placeholder="Enter Metric Name to Search"
                        size="small"/>
                    </div>
                    <div class="indicator-wrapper">  
                        <div class="indicator-side">
                            <div
                                :class="[
                                'indicator-category',
                                category == item.type ? 'indicator-category--active' : '',
                                ]"
                                v-for="(item, key, index) in indicatorData"
                                :key="key"
                                @click="changeCategory(item, index)"
                                v-show="categoryShow(item)"
                                >
                                {{ item.display_name }}
                            </div>
                        </div>
                        <!-- 勾选框区域 -->
                        <div class="indicator-body">
                            <div
                            class="indicator-block"
                            v-for="(pitem, key) in indicatorData"
                            :key="key"
                            v-show="categoryShow(pitem)"
                            >
                                <div class="indicator-group mb10">
                                    <el-checkbox
                                        class="ml10"
                                    :value="pitem.checked"
                                    :reset-data="resetData"
                                    :indeterminate="pitem.isIndeterminate"
                                    true-label="true"
                                     false-label="false"
                                    @change="handleCheckAllChange(!pitem.checked, pitem.type, pitem)">
                                    {{ pitem.display_name }}
                                    </el-checkbox>
                                </div>
                                <div>
                                    <div class="dragArea list-group el-row">
                                        <el-row :gutter="0">
                                            <el-col :span="8" v-for="(element, index) in pitem.children" :key="element.name"  v-show="indicatorShow(element)">
                                                <el-checkbox
                                                    class="mb10"
                                                    :value="element.checked"
                                                    :reset-data="resetData"
                                                    :label="element"
                                                    :disabled="element.disable"
                                                    true-label="true"
                                                    false-label="false"
                                                    @change="checkItem(!element.checked, element, key)">
                                                        <span v-if="element['display_name'] && element['display_name'].length < 15">{{ element['display_name'] }}</span>
                                                        <el-tooltip
                                                            v-else
                                                            effect="dark" :content="element['display_name']"
                                                            placement="top"
                                                            :open-delay="200">
                                                            <span>{{ element['display_name'].substring(0 , 14) }}...</span>
                                                        </el-tooltip>
                                                </el-checkbox>
                                                <el-tooltip
                                                    v-if="element['field_type'] == 2 && element['meconfig']"
                                                    effect="dark" :content="toquestiontitle(element['meconfig'])"
                                                    placement="top"
                                                    :open-delay="200">
                                                    <span class="questions">?</span>
                                                </el-tooltip>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- 右侧 -->
                <div class="indicator-drag">
                    <div class="drag-title">
                        <span><i>{{ Number(fixedData.length) + Number(dragData.length) }}</i> Fields Selected</span>
                        <span @click="handleClear">Clear All</span>
                    </div>
                    <!-- 以下指标将横向固定 -->
                    <div class="indicator-drag-srcoll">
                        <p class="pl8 font12px text-bold mt6 mb6">Freeze Columns</p>
                        <Draggable
                            ghost-class="drag-ghost"
                        :class="['indicator-limit-many']"
                        :list="fixedData"
                        :group="{ name: 'dragGroup', put: true }"
                        item-key="value"
                        @change="topGroupChange">
                            <div
                                :class="[
                                'indicator-drag-block',
                                'drag-block',
                                'hover-class',
                                'all-scroll',
                                'mg5',
                                ]"
                                v-for="(element, index) in fixedData"
                                :key="index"
                                >
                                <div class="indicator-drag-block-left">
                                    <i class="el-icon-rank" style="margin-right: 4px;"></i>
                                    <span class="indicator-name font12px">{{ element.display_name }}</span>
                                </div>
                                <i class="el-icon-close text-color-error" @click="changeDrag(element, 2, 'top')" v-if="element.no_drop != 1"></i>
                            </div>
                        </Draggable>
                        <p class="fixed_line font12px tac pt10 pb10 text-bold">Do Not Freeze Columns</p>
                        <!--可拖拽指标-->
                        <Draggable
                            ghost-class="drag-ghost"
                            class="indicator-limit-many"
                            :list="dragData"
                            :group="{ name: 'dragGroup', put: true }"
                            item-key="value"
                            ref="indicatorDragRef"
                            @change="bottomGroupChange">
                            <div
                                :class="[
                                'indicator-drag-block',
                                'drag-block',
                                'hover-class',
                                'all-scroll',
                                'mg5',
                                ]"
                                v-for="(element, index) in dragData"
                                :key="index"
                            >
                                <div class="indicator-drag-block-left">
                                    <i class="el-icon-rank" style="margin-right: 4px;"></i>
                                    <span class="indicator-name font12px">{{ element.display_name }}</span>
                                </div>
                                
                                <i class="el-icon-close text-color-error" title="Delete" @click="changeDrag(element, 2, 'bottom')" v-if="element.no_drop != 1"></i>
                            </div>
                        </Draggable>
                    </div>
                    
                    
                    <!-- <div class="indicator-drag-srcoll" style="min-height: 300px;">
                        
                    </div> -->
                </div>

            </div>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button class="confirm-btn" @click="()=> dialogVisible = false">Cancel</el-button>
            <el-button type="primary" :disabled="customBtnLoading" class="confirm-btn" @click="saveFn">Submit</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import Draggable from 'vuedraggable';
    import { uniqBy, throttle } from 'lodash'
    export default {
        name: "customizeModal",
        components: {
            Draggable
        },
        props:{
            customList: Array, //所有
            selectList: Array,  //选中
            customBtnLoading: false
        },
        data(){
            return {
                dialogVisible: false,
                resetData: false, //vue2 深度对象 无法触发视图更新。 使用此方法。
                loading:false,
                keyword: '',
                category: '',
                disabledlist: [], //不删除列。
                dragData: [],  //非冻结列
                fixedData: [], //冻结列
                indicatorData: {},
                dialogHeight: '500px'
            }
        },
        mounted() {
            // let { all = [], selected = [] } = mockjson
            // this.initIndicatorData(all, [])
            this.handleWindowResize()
            const throttledResizeHandler = throttle(this.handleWindowResize, 200);
            window.addEventListener('resize', throttledResizeHandler);

        },
        methods:{
            handleWindowResize() {
                let apple_wrapper_height = window.innerHeight  - 180
                if(apple_wrapper_height > 600) {
                    this.dialogHeight = `550px`
                }else{
                    this.dialogHeight = `${apple_wrapper_height}px`
                }
            },
            toquestiontitle(val) {
                console.log('val', val)
                return val.title
            },
            handleClose(){
                this.dialogVisible = false; 
            },
            showModal(){
                console.log('this.customList',this.customList)
                this.initIndicatorData(this.customList, this.selectList)
                this.dialogVisible = true;
            },
            //初始化数据
            initIndicatorData (allData, selectedData = []) {
                console.log('allData', allData)
                console.log('selectedData', selectedData)
                let getSelectList = selectedData.map(item=>item.name)
                let realist = []
                allData.forEach((el) => {
                    el["type"] = el.name + "_"
                    el["label"] = el.display_name
                    let checkedData = []
                    // el["stow"] = el.display_name == "维度指标" ? true : false
                    el.children.filter((l) => {
                        l["type"] = el["type"]
                        l["label"] = l.display_name
                        
                        if(l["field_type"] == 1) {
                            l["disable"] = l['meconfig']['disable'] && l['meconfig']['disable'] == 'true' ? true : false
                        }
                        // l["disable"] = l.disable && l.disable ? true : false

                        if ((l["disable"]) || getSelectList.includes(l.name)) {
                            checkedData.push(l)
                            l["checked"] = true
                        } else {
                            l["checked"] = false
                        }
                    })
                    el["checkedData"] = checkedData
                    el["checked"] =
                    checkedData.length > 0 && checkedData.length == el.children.length
                        ? true
                        : false
                    el["isIndeterminate"] = el.checked
                    ? false
                    : checkedData.length > 0 && checkedData.length < el.children.length
                        ? true
                        : false
                    this.indicatorData[el.type] = el
                    realist.push(...checkedData)
                })
                this.category =
                    allData.length > 0 ? Object.values(this.indicatorData)[0]["type"] : ""
                // this.stow = true //默认不展示所有
                
                this.disabledlist = realist.filter(item=> item['meconfig']['disable'] && item['meconfig']['disable'] == 'true').map(item=>item.name)
                console.log('isdisabledlist', this.disabledlist)
                let uni_fixed_data = []
                let uni_drag_data = []
                selectedData.forEach((el) => {
                    if(el.label != '' && el.label != undefined) {
                        el["display_name"] = el.label
                    }else{
                        el["display_name"] = el["display_name"]
                    }
                    if(this.disabledlist.includes(el.name)) {
                        el["no_drop"] = 1
                    }else{
                        el["no_drop"] = ''
                    }
                    el["type"] = el.name + "_"
                    if (el.fixed == "left"
                    ) {
                        uni_fixed_data.push({
                            name: el['name'], 
                            field_type: el['field_type'],
                            width: 120,
                            display_name:el["display_name"], 
                            fixed: el['fixed'],
                            config: el['config'],
                            no_drop: el['no_drop'],
                            label: el['label']
                        })
                    } else {
                        uni_drag_data.push({
                            name: el['name'], 
                            field_type: el['field_type'],
                            width: 120, 
                            display_name:el["display_name"], 
                            config: el['config'],
                            no_drop: el['no_drop'],
                            fixed: el['fixed'],
                            label: el['label']
                        })
                    }
                })
                
                this.fixedData = uniqBy(uni_fixed_data, 'name')
                this.dragData = uniqBy(uni_drag_data, 'name')
                // this.dragData = selectedData;
                this.loading = false
            },
            categoryShow(item) {
                
                if (this.keyword) {
                    console.log('this.keyword', this.keyword)
                if (item.display_name.indexOf(this.keyword) > -1) {
                    return true
                } else {
                    let matching = item.children.filter((el) => {
                    return el.display_name.indexOf(this.keyword) > -1
                    })
                    return matching.length > 0 ? true : false
                }
                } else {
                    return true
                }
            },
            indicatorShow(item) {
                if (this.keyword) {
                return item.display_name.indexOf(this.keyword) > -1 ? true : false
                } else {
                return true
                }
            },
            topGroupChange(evt) {
                if (evt.added) {
                let { element, newIndex } = evt.added
                element.fixed = "left"
                }
            },
            bottomGroupChange(evt) {
                //左侧向右侧添加数据 时
                if (evt.added) {
                let { element, newIndex } = evt.added
                element.fixed = ""

                // this.changeDrag(element, 1)
                // let rightGroup = JSON.parse(JSON.stringify(this.dragData)),
                //     matchingIndexs = -1
                // rightGroup.forEach((el, i) => {
                //     if (element.name == el.name && newIndex !== i) {
                //     matchingIndexs = i
                //     }
                // })
                // if (matchingIndexs !== -1) {
                //     rightGroup.splice(matchingIndexs, 1)
                // }
                // this.dragData = rightGroup
                // }
                }
            },
            changeDrag(item, status, desc) {
                if(desc == 'bottom') {
                    this.changeCheckbox(this.dragData, item, status)
                }else{
                    this.changeCheckbox(this.fixedData, item, status)
                }
                let values = Object.keys(this.indicatorData)
                values.forEach(ele=>{
                    this.indicatorData[ele].children.forEach((el) => {
                        if (el.name == item.name) {
                            el.checked = status == 1 ? true : false
                            this.checkItem(el.checked, el, el.type)
                        }
                    })
                })
            },
            changeCategory(item, index) {
                this.category = item.type
                let jump = document.querySelectorAll(".indicator-block")
                this.$nextTick(() => {
                    jump[index].scrollIntoView()
                })
            },
            checkItem(val, el, type) {
                this.resetData = !this.resetData
                el.checked = val
                this.changeCheckbox(
                    this.indicatorData[type]["checkedData"],
                    el,
                    val ? 1 : 2
                )
                if(val) {
                    this.changeCheckbox(this.dragData, el, val ? 1 : 2)
                }else{
                    this.changeCheckbox(this.dragData, el, val ? 1 : 2)
                    this.changeCheckbox(this.fixedData, el, val ? 1 : 2)
                }
                let checkedCount = this.indicatorData[type]["checkedData"].length
                this.indicatorData[type].checked =
                checkedCount === this.indicatorData[type].children.length
                this.indicatorData[type].isIndeterminate = this.isIndeterminateStatus(
                type,
                checkedCount
                )

                // this.$nextTick(()=>{
                //     this.$set(this.indicatorData, type, this.indicatorData[type])
                // })
            },
            handleCheckAllChange(val, index, ele) {
                this.resetData = !this.resetData
                // Select All／返选
                let arr = []
                ele.checked = val
                const re = this.indicatorData[index].children
                re.forEach((el) => {
                    if (!el.disable) {
                        el.checked = val
                        let f_index = this.fixedData.findIndex((v) => v.name == el.name)
                        let d_index = this.dragData.findIndex((v) => v.name == el.name)
                        if (el.checked) {
                            arr.push(el)
                            if (d_index == -1 && f_index == -1) {
                                this.dragData.push(
                                    {
                                        name: el['name'], 
                                        field_type: el['field_type'],
                                        width: 120, 
                                        display_name:el["display_name"], 
                                        config: el['config'],
                                        fixed: el['fixed'],
                                        no_drop: !el['no_drop'] ? '' : el['no_drop'],
                                        label: el['label']
                                    }
                                )
                            }
                        } else {
                            if (f_index > -1) {
                                this.fixedData.splice(f_index, 1)
                            }
                            if (d_index > -1) {
                                this.dragData.splice(d_index, 1)
                            }
                        }
                    } else {
                        arr.push(el)
                    }
                })
                
                this.indicatorData[index].checkedData = arr
                this.indicatorData[index].isIndeterminate = this.isIndeterminateStatus(index, arr.length)
                // this.$nextTick(()=>{
                //     this.$set(this.indicatorData, index, this.indicatorData[index])
                // })
                
            },
            isIndeterminateStatus(index, checkedCount) {
                return (
                checkedCount > 0 &&
                checkedCount < this.indicatorData[index].children.length
                )
            },
            changeCheckbox(arr = [], el, type) {
                let i = arr.findIndex((v) => v.name === el.name)
                switch (type) {
                case 1:
                    if (i == -1) {
                    arr.push({
                        name: el['name'], 
                        field_type: el['field_type'],
                        width: 120, 
                        display_name:el["display_name"], 
                        config: el['config'],
                        no_drop: !el['no_drop'] ? '' : el['no_drop'],
                        fixed: el['fixed'],
                        label: el['label']
                    })
                    }
                    break
                case 2:
                    if (i !== -1) {
                    arr.splice(i, 1)
                    }
                    break
                }
            },
            saveFn() {
                let outList = uniqBy([...this.fixedData, ...this.dragData], 'name')
                console.log('结果', outList)
                this.$emit('getCustomList', outList)
            },
            // 清除全部
            handleClear() {
                let residue_fixed = this.fixedData.filter(item=>this.disabledlist.includes(item.name))
                let residue_drag = this.dragData.filter(item=>this.disabledlist.includes(item.name))
                this.fixedData = residue_fixed
                this.dragData = residue_drag

                let values = Object.keys(this.indicatorData)
                values.forEach(ele=>{
                    let checkedData = []
                    this.indicatorData[ele].children.forEach((item) => {
                        if ((item.disable && item.disable == true)) {
                            checkedData.push(item)
                            item["checked"] = true
                        } else {
                            item["checked"] = false
                        }
                    })
                    this.indicatorData[ele]["checkedData"] = checkedData
                    this.indicatorData[ele]["checked"] = checkedData.length > 0 && checkedData.length == this.indicatorData[ele].children.length ? true : false
                    this.indicatorData[ele]["isIndeterminate"] = this.indicatorData[ele].checked ? false : checkedData.length > 0 && checkedData.length < this.indicatorData[ele].children.length ? true : false
                })
            }
        }
    }
</script>

<style lang="scss">
.custom-indicator {
  .el-dialog__header {
    box-sizing: content-box;
    margin-right: 0;
    font-size: 18px;
    font-weight: 700;
    line-height: 18px;
    border-bottom: 1px solid #e8eaec;
  }
  .el-dialog__body{
    padding: 0 0px 16px 0px;
  }
  .questions {
        width: 12px;
        height: 12px;
        line-height: 12px;
        text-align: center;
        border-radius: 10px;
        background-color: #333;
        color: #fff;
        font-size: 12px;
        display: inline-block;
        margin-left: 3px;
        cursor: pointer;
    }
  .wrapper{
    display: flex;
    width: 100%;
  }
  .top-wrapper {
    display: flex;
    justify-content: flex-start;
    border: 1px solid #eaebec;
    border-top: none;
    border-bottom: none;
    align-items: center;
    height: 50px;
    padding-left: 8px;
  }

  .search {
    width: 250px;
  }
  
  .indicator-wrapper {
    display: flex;
    width: 100%;
    height: 500px;
    border: 1px solid #eaebec;
    border-radius: 4px;
  }

  .indicator-side {
    flex-shrink: 0;
    width: 160px;
    flex: 0 0 160px;
    overflow: auto;
    border-right: 1px solid #eaebec;
  }

  .indicator-category {
    padding-left: 16px;
    font-size: 14px;
    line-height: 40px;
    color: #333;
    cursor: pointer;
  }

  .item-stow {
    float: right;
    margin-right: 20px;
    cursor: pointer;
    color: #197afb;
    font-size: 13px;
    line-height: 32px;
  }

  .indicator-category--active {
    color: #197afb;
    background-color: #d6eaff;
  }

  .indicator-body {
    flex: auto;
    // overflow: auto;
    overflow-y: auto;
    max-height: 500px;
    scroll-behavior: smooth;
  }

  .indicator-block {
    padding: 8px 12px;
    border-bottom: 1px solid #eaebec;

    .el-checkbox__label {
      font-size: 12px;
      font-weight: 400;
    }
  }

  .dragArea {
    // padding-left: 10px;
  }

  .indicator-group {
    position: relative;
    background-color: #f2f2f2;
    padding: 6px 0;
    .el-checkbox__label {
      font-size: 14px;
      font-weight: bold;
    }
  }

  .indicator-drag {
    width: 225px;
    flex: 0 0 225px;
    height: 550px;
    padding: 0 0 25px 0;
    background-color: #fff;
    border: 1px solid #eaebec;
    border-top: none;
    z-index: 1;
    box-sizing: border-box;

    .drag-title {
      font-size: 14px;
      font-weight: 600;
      line-height: 100%;
      color: #333;
      padding: 0 10px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #eaebec;
      span{
        &:first-child{
            i{
                color: #197afb;
                font-style: normal;
            }
        }
        &:last-child{
            cursor: pointer;
            color: #ff0000;
        }
      }
    }

    .drag-sec {
      margin: 8px 0;
      font-size: 12px;
      line-height: 100%;
      color: #999;
      padding: 0 10px;
      font-weight: bold;
    }

    .indicator-drag-block.not-allow {
      cursor: not-allowed;
    }

    .indicator-content {
      // padding: 0 12px;
    }

    .mg5 {
      margin-bottom: 5px;
    }
    .fixed_line{
        position: relative;
        &::before {
            position: absolute;
            top: 20px;
            left: 12px;
            width: 18px;
            height: 1px;
            content: "";
            background-color: #999;
        }

        &::after {
            position: absolute;
            top: 20px;
            right: 12px;
            width: 18px;
            height: 1px;
            content: "";
            background-color: #999;
        }
    }

    .indicator-drag-block {
      position: relative;
      width: 195px;
      height: 30px;
      padding: 0 8px 0 8px;
      overflow: hidden;
      line-height: 30px;
      text-overflow: ellipsis;
      white-space: nowrap;
      background-color: #f2f2f2;
      border: 1px solid #e8eaec;
        border-radius: 3px;
      cursor: pointer;
      display: flex;
      align-items:center;
      justify-content: space-between;
    
      &.hide_ {
        display: none;
      }
      .indicator-drag-block-left{
        display: flex;
        align-items:center;
      }

      .indicator-name {
        display: inline-block;
        width: 150px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .indicator-drag-srcoll{
        overflow-y: auto;
        max-height: 470px;
        scroll-behavior: smooth;
    }
    .drag-block.hover-class {
      &:hover {
        .edit-close {
          display: block;
        }
      }
    }

    .drag-block.selectedClass {
      background: #ecf5ff;
      cursor: all-scroll;
    }

    .drag-sepreate {
      position: relative;
      margin: 10px 0 10px;
      font-size: 12px;
      color: #999;
      text-align: center;
      font-weight: bold;

      &::before {
        position: absolute;
        top: 9px;
        left: 0;
        width: 32px;
        height: 1px;
        content: "";
        background-color: #e8eaec;
      }

      &::after {
        position: absolute;
        top: 9px;
        right: 0;
        width: 32px;
        height: 1px;
        content: "";
        background-color: #e8eaec;
      }
    }

    .indicator-limit-many {
      padding: 0 0 0 8px;
    }
  }
}

.stow-icon {
  color: #409eff;
  cursor: pointer;
}

.el-color-picker .el-color-picker__empty {
  display: none;
}

.el-popper.color-popper {
  width: 200px;

  .el-color-dropdown__main-wrapper {
    display: none;
  }

  .el-color-dropdown__btns {
    .el-color-dropdown__value {
      width: 70px;

      .el-input__inner {
        pointer-events: none;
        box-shadow: none;
      }
    }
  }
}
</style>
